"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SingleOptionModel = exports.FilterModel = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
require("core-js/modules/es6.function.name.js");
require("core-js/modules/es6.string.small.js");
function cov_zb3e1vkhn() {
  var path = "/codebuild/output/src3193688389/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/filter/lib/model.js";
  var hash = "2ce0f348f1a7c4b1b3167e8200e65a50c67fd015";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3193688389/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/filter/lib/model.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 33
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "1": {
        start: {
          line: 10,
          column: 42
        },
        end: {
          line: 10,
          column: 48
        }
      },
      "2": {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 81
        }
      },
      "3": {
        start: {
          line: 12,
          column: 24
        },
        end: {
          line: 18,
          column: 5
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 39
        }
      },
      "5": {
        start: {
          line: 23,
          column: 24
        },
        end: {
          line: 26,
          column: 5
        }
      },
      "6": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 39
        }
      },
      "7": {
        start: {
          line: 32,
          column: 27
        },
        end: {
          line: 32,
          column: 29
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 7
          },
          end: {
            line: 9,
            column: 8
          }
        },
        loc: {
          start: {
            line: 9,
            column: 49
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 22,
            column: 18
          },
          end: {
            line: 22,
            column: 19
          }
        },
        loc: {
          start: {
            line: 22,
            column: 55
          },
          end: {
            line: 29,
            column: 3
          }
        },
        line: 22
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 22
          },
          end: {
            line: 9,
            column: 44
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 9,
            column: 39
          },
          end: {
            line: 9,
            column: 44
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 11,
            column: 17
          },
          end: {
            line: 11,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 11,
            column: 17
          },
          end: {
            line: 11,
            column: 26
          }
        }, {
          start: {
            line: 11,
            column: 31
          },
          end: {
            line: 11,
            column: 50
          }
        }, {
          start: {
            line: 11,
            column: 54
          },
          end: {
            line: 11,
            column: 80
          }
        }],
        line: 11
      },
      "2": {
        loc: {
          start: {
            line: 13,
            column: 13
          },
          end: {
            line: 13,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 13,
            column: 31
          },
          end: {
            line: 13,
            column: 38
          }
        }, {
          start: {
            line: 13,
            column: 41
          },
          end: {
            line: 13,
            column: 45
          }
        }],
        line: 13
      },
      "3": {
        loc: {
          start: {
            line: 17,
            column: 12
          },
          end: {
            line: 17,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 12
          },
          end: {
            line: 17,
            column: 21
          }
        }, {
          start: {
            line: 17,
            column: 25
          },
          end: {
            line: 17,
            column: 40
          }
        }],
        line: 17
      },
      "4": {
        loc: {
          start: {
            line: 25,
            column: 13
          },
          end: {
            line: 25,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 13
          },
          end: {
            line: 25,
            column: 22
          }
        }, {
          start: {
            line: 25,
            column: 27
          },
          end: {
            line: 25,
            column: 46
          }
        }, {
          start: {
            line: 25,
            column: 50
          },
          end: {
            line: 25,
            column: 76
          }
        }],
        line: 25
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2ce0f348f1a7c4b1b3167e8200e65a50c67fd015"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_zb3e1vkhn = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_zb3e1vkhn();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var SingleOptionModel = exports.SingleOptionModel = (cov_zb3e1vkhn().s[0]++, {
  /**
   * This function is used to transform site data received by the server to site data option that will be used in
   * the nucleo (state) and all the functional components
   * @param {object} data, it is the value of site received by the server
   * @param {ConfigType} config, it is the nucleo config object
   * @returns SingleOptionType
   */
  get: function get(data, config) {
    var useNameAsValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_zb3e1vkhn().b[0][0]++, false);
    cov_zb3e1vkhn().f[0]++;
    var _ref = (cov_zb3e1vkhn().s[1]++, config),
      language = _ref.language,
      defaultLanguage = _ref.defaultLanguage;
    var name = (cov_zb3e1vkhn().s[2]++, (cov_zb3e1vkhn().b[1][0]++, data.name) && ((cov_zb3e1vkhn().b[1][1]++, data.name[language]) || (cov_zb3e1vkhn().b[1][2]++, data.name[defaultLanguage])));
    var adaptedData = (cov_zb3e1vkhn().s[3]++, {
      value: !useNameAsValue ? (cov_zb3e1vkhn().b[2][0]++, data.id) : (cov_zb3e1vkhn().b[2][1]++, name),
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: data.name,
      label: name,
      icon: (cov_zb3e1vkhn().b[3][0]++, data.logo) && (cov_zb3e1vkhn().b[3][1]++, data.logo.small)
    });
    cov_zb3e1vkhn().s[4]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  },
  changeLanguage: function changeLanguage(data, language, defaultLanguage) {
    cov_zb3e1vkhn().f[1]++;
    var adaptedData = (cov_zb3e1vkhn().s[5]++, {
      // get the translated objects to avoid computing it everywhere, but keep all translations
      label: (cov_zb3e1vkhn().b[4][0]++, data.name) && ((cov_zb3e1vkhn().b[4][1]++, data.name[language]) || (cov_zb3e1vkhn().b[4][2]++, data.name[defaultLanguage]))
    });
    cov_zb3e1vkhn().s[6]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  }
});
var FilterModel = exports.FilterModel = (cov_zb3e1vkhn().s[7]++, {});
var _default = exports.default = FilterModel;